import React, { useMemo } from 'react';

import {
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
} from '@material-ui/core';
import VisibilityIcon from '@material-ui/icons/Visibility';
import moment from 'moment';
import PropTypes from 'prop-types';

import { t, number, can } from '~/helpers';

import { WrapperTabela } from './styles';

import { MODULO_CUSTOMIZACAO_RUMO } from '~/constants/modules';

//
export default function TablePitStopTempos({ rows, onIconClick }) {
  const headers = useMemo(() =>
    can(MODULO_CUSTOMIZACAO_RUMO)
      ? [
          t('s.geral.postocomboio'),
          t('s.cadastro.pitstop.codigoatendimento'),
          t('s.menu.configuracao.bico'),
          t('s.menu.cadastro.veiculo.locomotiva'),
          t('s.menu.operacao.turno'),
          t('s.geral.opcoes.datahorainicial'),
          t('s.geral.opcoes.datahorafinal'),
          t('s.relatorio.pitstoptempos.pst'),
          t('s.configuracao.produto.calculodensidadeproduto.diesel'),
          t('s.cadastro.pitstop.banheiroatendimentolimpeza'), // banheiro
          t('s.cadastro.pitstop.areia'),
          t('s.cadastro.pitstop.limpeza'),
          t('s.geral.opcoes.lubrificante'),
          t('s.relatorio.pitstoptempos.ipl'),
        ]
      : [
          t('s.geral.postocomboio'),
          t('s.cadastro.pitstop.codigoatendimento'),
          t('s.menu.configuracao.bico'),
          t('s.menu.cadastro.veiculo.locomotiva'),
          t('s.menu.operacao.turno'),
          t('s.geral.opcoes.datahorainicial'),
          t('s.geral.opcoes.datahorafinal'),
          t('s.relatorio.pitstoptempos.pst'),
          t('s.configuracao.produto.calculodensidadeproduto.diesel'),
          t('s.cadastro.pitstop.agua'), // agua
          t('s.cadastro.pitstop.areia'),
          t('s.cadastro.pitstop.limpeza'),
          t('s.geral.opcoes.lubrificante'),
          t('s.relatorio.pitstoptempos.ipl'),
        ]
  );

  return (
    <WrapperTabela height="80vh">
      <TableContainer>
        <Table stickyHeader aria-label="sticky table" size="small">
          <TableHead>
            <TableRow>
              {headers.map((header, index) => (
                <TableCell align="center" key={`cell-index-head-${index}`}>
                  {header}
                </TableCell>
              ))}
              <TableCell key="cell-index-head-99" style={{ padding: 0 }} />
            </TableRow>
          </TableHead>
          <TableBody>
            {rows.map((row, index) => (
              <TableRow hover tabIndex={-1} key={`table-row-body-${index}`}>
                <TableCell key="table-cell-body-1">
                  {row.codigonomeposto}
                </TableCell>
                <TableCell key="table-cell-body-2" align="right">
                  {row.codigoatendimento}
                </TableCell>
                <TableCell key="table-cell-body-3" align="right">
                  {row.idbicoabastecimento}
                </TableCell>
                <TableCell key="table-cell-body-4">{row.idveiculo}</TableCell>
                <TableCell key="table-cell-body-5" align="right">
                  {row.numeroturno}
                </TableCell>
                <TableCell key="table-cell-body-6" align="center">
                  {moment(row.dataencosteatendimento).format(
                    'DD/MM/YYYY HH:mm:ss'
                  )}
                </TableCell>
                <TableCell key="table-cell-body-7" align="center">
                  {moment(row.dataliberacaoatendimento).format(
                    'DD/MM/YYYY HH:mm:ss'
                  )}
                </TableCell>
                <TableCell key="table-cell-body-8" align="center">
                  {row.duracaoatendimento
                    ? moment(row.duracaoatendimentodate).format('HH:mm')
                    : '00:00'}
                </TableCell>
                <TableCell key="table-cell-body-9" align="center">
                  {row.duracaoabastecimento
                    ? moment(row.duracaoabastecimento).format('HH:mm')
                    : '00:00'}
                </TableCell>
                <TableCell key="table-cell-body-10" align="center">
                  {can(MODULO_CUSTOMIZACAO_RUMO)
                    ? row.duracaobanheiro
                      ? moment(row.duracaobanheiro).format('HH:mm')
                      : '00:00'
                    : row.duracaoagua
                    ? moment(row.duracaoagua).format('HH:mm')
                    : '00:00'}
                </TableCell>
                <TableCell key="table-cell-body-11" align="center">
                  {row.duracaoareia
                    ? moment(row.duracaoareia).format('HH:mm')
                    : '00:00'}
                </TableCell>
                <TableCell key="table-cell-body-12" align="center">
                  {row.duracaolimpeza
                    ? moment(row.duracaolimpeza).format('HH:mm')
                    : '00:00'}
                </TableCell>
                <TableCell key="table-cell-body-13" align="center">
                  {row.duracaolubrificacao
                    ? moment(row.duracaolubrificacao).format('HH:mm')
                    : '00:00'}
                </TableCell>
                <TableCell key="table-cell-body-14" align="right">
                  {number(row.iplatendimento, 1)}
                </TableCell>
                <TableCell
                  key="table-cell-body-99"
                  style={{ padding: 4 }}
                  align="center"
                >
                  <div title={t('s.cadastro.pitstop.atendimento')}>
                    <VisibilityIcon
                      fontSize="small"
                      onClick={() => onIconClick(row.idatendimento)}
                      style={{
                        color: '#999999',
                        cursor: 'pointer',
                      }}
                    />
                  </div>
                </TableCell>
              </TableRow>
            ))}
          </TableBody>
        </Table>
      </TableContainer>
    </WrapperTabela>
  );
}

TablePitStopTempos.propTypes = {
  rows: PropTypes.arrayOf(PropTypes.object).isRequired,
  onIconClick: PropTypes.func.isRequired,
};
